var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-block"},[_c('v-container',{staticClass:"title-wrapper"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }